const BREAKPOINTS = {
  XS: 0,
  SM: 375,
  MD: 992,
  LG: 1280,
  XL: 1600,
};

export default BREAKPOINTS;
